export default Object.freeze({
  Gregorian: 0,
  Solar: 1,
});
